// Shared content for /services — used by both the Service page component and
// App.js's structured data, so visible copy and JSON-LD never drift apart.
// Kept as a plain data module (no React/CSS) so importing it from App.js does
// not pull the lazy-loaded Service page into the main bundle.

export const serviceGroupSlug = (title) =>
  title.replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const serviceGroups = [
  {
    number: "01",
    title: "groups.automation.title",
    intro: "groups.automation.intro",
    services: [
      "groups.automation.services.aiAutomation",
      "groups.automation.services.privateLocalAi",
      "groups.automation.services.processOptimisation",
      "groups.automation.services.customTools",
    ],
  },
  {
    number: "02",
    title: "groups.webDigital.title",
    intro: "groups.webDigital.intro",
    services: [
      "groups.webDigital.services.webDevelopment",
      "groups.webDigital.services.digitalisation",
    ],
  },
  {
    number: "03",
    title: "groups.finance.title",
    intro: "groups.finance.intro",
    services: [
      "groups.finance.services.finance",
      "groups.finance.services.creativeDevelopment",
    ],
  },
  {
    number: "04",
    title: "groups.brandDesign.title",
    intro: "groups.brandDesign.intro",
    services: [
      "groups.brandDesign.services.brandingIdentity",
      "groups.brandDesign.services.graphicDesign",
      "groups.brandDesign.services.communication",
    ],
  },
];


export const faqs = "faq.questions";
